import React from 'react';



export const Nav = () => {

    return(
        <nav
        aria-label="primary"
        data-test="cms-primary-nav"
        className="cms-primary-nav"
      >
        <ul className="cms-primary-nav__list">
          <li className="cms-nav-item">
            <div className="cms-nav-item__link cms-nav-item__link--parent">
              <a
                id=""
                title="Home"
                data-test="home-nav-link"
                className="cont_-IWPn0lJWClXD77WP3rXj link-content__link nav-link"
                href="https://health.aetna.com/"
              >
                <span className="cms-nav-item__link-text">Home</span>
              </a>
            </div>
          </li>
          <li className="cms-nav-item">
            <div className="cms-nav-item__link cms-nav-item__link--active cms-nav-item__link--parent">
              <a
                id=""
                title="Claims"
                data-test="claims-nav-link"
                className="cont_-IWPn0lJWClXD77WP3rXj link-content__link nav-link"
                aria-expanded="false"
                href="https://health.aetna.com/manage/claims"
                aria-current="page"
              >
                <span className="cms-nav-item__link-text">Claims</span>
              </a>
              <ul className="cms-sub-menu">
                <li className="cms-sub-menu__section-list">
                  <ul>
                    <li className="cms-sub-menu__item">
                      <div className="cms-sub-menu__link cms-nav-item__link--active">
                        <a
                          id=""
                          title="Claims"
                          data-test="claims-nav-link"
                          className="cont_-IWPn0lJWClXD77WP3rXj link-content__link nav-link"
                          href="https://health.aetna.com/manage/claims"
                          aria-current="page"
                        >
                          <span className="cms-nav-item__link-text">
                            Claims
                          </span>
                        </a>
                      </div>
                    </li>
                    <li className="cms-sub-menu__item">
                      <div className="cms-sub-menu__link">
                        <a
                          id=""
                          title="Explanation of Benefits (EOB) Statements"
                          data-test="explanation-of-benefits-eob-statements-nav-link"
                          className="cont_-IWPn0lJWClXD77WP3rXj link-content__link nav-link"
                          href="https://health.aetna.com/eob"
                        >
                          <span className="cms-nav-item__link-text">
                            Explanation of Benefits (EOB) Statements
                          </span>
                        </a>
                      </div>
                    </li>
                  </ul>
                  <div className="cms-sub-menu__divider" />
                </li>
                <li className="cms-sub-menu__section-list">
                  <ul>
                    <li className="cms-sub-menu__item">
                      <div className="cms-sub-menu__link">
                        <a
                          id=""
                          title="Review Prior Authorizations"
                          data-test="review-prior-authorizations-nav-link"
                          className="cont_-IWPn0lJWClXD77WP3rXj link-content__link nav-link"
                          href="https://health.aetna.com/manage/coverage-requests"
                        >
                          <span className="cms-nav-item__link-text">
                            Review Prior Authorizations
                          </span>
                        </a>
                      </div>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </li>
          <li className="cms-nav-item">
            <div className="cms-nav-item__link cms-nav-item__link--parent">
              <a
                id=""
                title="Health & Wellness"
                data-test="health-wellness-nav-link"
                className="cont_-IWPn0lJWClXD77WP3rXj link-content__link nav-link"
                aria-expanded="false"
                href="https://health.aetna.com/healthprograms"
              >
                <span className="cms-nav-item__link-text">
                  Health &amp; Wellness
                </span>
              </a>
              <ul className="cms-sub-menu">
                <li className="cms-sub-menu__item">
                  <div className="cms-sub-menu__link">
                    <a
                      id=""
                      title="Go to Health & Wellness"
                      data-test="go-to-health-wellness-nav-link"
                      className="cont_-IWPn0lJWClXD77WP3rXj link-content__link nav-link"
                      href="https://health.aetna.com/healthprograms"
                    >
                      <span className="cms-nav-item__link-text">
                        Go to Health &amp; Wellness
                        <svg
                          className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-e6TXteWBj4Og8INecdNQ svg"
                          data-test="arrow-right-icon"
                          aria-label="arrow right"
                          role="img"
                          aria-hidden="true"
                        >
                          <title data-test="arrow-right-icon-title">
                            arrow right
                          </title>
                          <use xlinkHref="#arrow-right" />
                        </svg>
                      </span>
                    </a>
                  </div>
                  <div className="cms-sub-menu__divider" />
                </li>
                <li className="cms-sub-menu__item">
                  <div className="cms-sub-menu__link">
                    <a
                      className="nav-link"
                      data-test="wellness-tools-nav-link-hash"
                      href="https://health.aetna.com/healthprograms#wellness-tools"
                    >
                      <span className="cms-nav-item__link-text">
                        Wellness Tools
                      </span>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </li>
          <li className="cms-nav-item">
            <div className="cms-nav-item__link cms-nav-item__link--parent">
              <a
                id=""
                title="Support"
                data-test="support-nav-link"
                className="cont_-IWPn0lJWClXD77WP3rXj link-content__link nav-link"
                aria-expanded="false"
                href="https://health.aetna.com/support"
              >
                <span className="cms-nav-item__link-text">Support</span>
              </a>
              <ul className="cms-sub-menu">
                <li className="cms-sub-menu__item">
                  <div className="cms-sub-menu__link">
                    <a
                      id=""
                      title="Go to Support Center"
                      data-test="go-to-support-center-nav-link"
                      className="cont_-IWPn0lJWClXD77WP3rXj link-content__link nav-link"
                      href="https://health.aetna.com/support"
                    >
                      <span className="cms-nav-item__link-text">
                        Go to Support Center
                        <svg
                          className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-e6TXteWBj4Og8INecdNQ svg"
                          data-test="arrow-right-icon"
                          aria-label="arrow right"
                          role="img"
                          aria-hidden="true"
                        >
                          <title data-test="arrow-right-icon-title">
                            arrow right
                          </title>
                          <use xlinkHref="#arrow-right" />
                        </svg>
                      </span>
                    </a>
                  </div>
                  <div className="cms-sub-menu__divider" />
                </li>
                <li className="cms-sub-menu__item">
                  <div className="cms-sub-menu__link">
                    <a
                      aria-label="Contact Us (Opens in a new tab)"
                      className="cont_-IWPn0lJWClXD77WP3rXj link-content__link nav-link"
                      data-test="contact-us-nav-link"
                      href="https://member.aetna.com/secure/member/?v106#/openNavLite?deepLink=SSOPARTNERCONTACTUS"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="cms-nav-item__link-text">
                        Contact Us
                      </span>
                    </a>
                  </div>
                </li>
                <li className="cms-sub-menu__item">
                  <div className="cms-sub-menu__link">
                    <a
                      id=""
                      title="Documents"
                      data-test="documents-nav-link"
                      className="cont_-IWPn0lJWClXD77WP3rXj link-content__link nav-link"
                      href="https://health.aetna.com/documents"
                    >
                      <span className="cms-nav-item__link-text">
                        Documents
                      </span>
                    </a>
                  </div>
                </li>
                <li className="cms-sub-menu__item">
                  <div className="cms-sub-menu__link">
                    <a
                      id=""
                      title="Forms"
                      data-test="forms-nav-link"
                      className="cont_-IWPn0lJWClXD77WP3rXj link-content__link nav-link"
                      href="https://health.aetna.com/documents-and-forms"
                    >
                      <span className="cms-nav-item__link-text">
                        Forms
                      </span>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </nav>
    )
}

export const MobileNav = () => {

    return(<div data-test="cms-nav">
    <nav
      aria-label="primary"
      data-test="cms-primary-nav"
      className="cms-primary-nav"
    >
      <ul className="cms-primary-nav__list">
        <li className="cms-nav-item">
          <div className="cms-nav-item__link cms-nav-item__link--parent">
            <a
              className="nav-link cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2 cont_-qica1OLHiA9mg6daoVDb"
              data-test="home-nav-link"
              href="/"
            >
              <div className="cont_-xzf4zIOjrXt5rU5Pdx0v cms-nav-item__link-text">
                Home
              </div>
            </a>
          </div>
        </li>
        <li className="cms-nav-item cms-nav-item--open">
          <div className="cms-nav-item__link cms-nav-item__link--active cms-nav-item__link--parent">
            <button
              className="nav-link cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2 cont_-qica1OLHiA9mg6daoVDb"
              data-test="claims-nav-link"
              type="button"
              aria-expanded="true"
            >
              <div className="cont_-xzf4zIOjrXt5rU5Pdx0v cms-nav-item__link-text">
                Claims
              </div>
              <svg
                className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-WW6a0Ul_wZOcN9_J6EPn cont_-S6msaMk2pPmGHFiKKm7F"
                data-test="claims-nav-link-svg"
                aria-label="caret up"
                role="img"
                aria-hidden="true"
              >
                <title data-test="claims-nav-link-svg-title">caret up</title>
                <use xlinkHref="#anatomy-caret-up" />
              </svg>
            </button>
            <ul className="cms-sub-menu">
              <li className="cms-sub-menu__section-list">
                <ul>
                  <li className="cms-sub-menu__item">
                    <div className="cms-sub-menu__link cms-nav-item__link--active">
                      <a
                        id=""
                        title="Claims"
                        data-test="claims-nav-link"
                        className="cont_-IWPn0lJWClXD77WP3rXj link-content__link nav-link"
                        aria-current="page"
                        href="/manage/claims"
                      >
                        <span className="cms-nav-item__link-text">Claims</span>
                      </a>
                    </div>
                  </li>
                  <li className="cms-sub-menu__item">
                    <div className="cms-sub-menu__link">
                      <a
                        id=""
                        title="Explanation of Benefits (EOB) Statements"
                        data-test="explanation-of-benefits-eob-statements-nav-link"
                        className="cont_-IWPn0lJWClXD77WP3rXj link-content__link nav-link"
                        href="/eob"
                      >
                        <span className="cms-nav-item__link-text">
                          Explanation of Benefits (EOB) Statements
                        </span>
                      </a>
                    </div>
                  </li>
                </ul>
                <div className="cms-sub-menu__divider" />
              </li>
              <li className="cms-sub-menu__section-list">
                <ul>
                  <li className="cms-sub-menu__item">
                    <div className="cms-sub-menu__link">
                      <a
                        id=""
                        title="Review Prior Authorizations"
                        data-test="review-prior-authorizations-nav-link"
                        className="cont_-IWPn0lJWClXD77WP3rXj link-content__link nav-link"
                        href="/manage/coverage-requests"
                      >
                        <span className="cms-nav-item__link-text">
                          Review Prior Authorizations
                        </span>
                      </a>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </li>
        <li className="cms-nav-item">
          <div className="cms-nav-item__link cms-nav-item__link--parent">
            <button
              className="nav-link cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2 cont_-qica1OLHiA9mg6daoVDb"
              data-test="health-wellness-nav-link"
              type="button"
              aria-expanded="false"
            >
              <div className="cont_-xzf4zIOjrXt5rU5Pdx0v cms-nav-item__link-text">
                Health &amp; Wellness
              </div>
              <svg
                className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-WW6a0Ul_wZOcN9_J6EPn cont_-S6msaMk2pPmGHFiKKm7F"
                data-test="health-wellness-nav-link-svg"
                aria-label="caret down"
                role="img"
                aria-hidden="true"
              >
                <title data-test="health-wellness-nav-link-svg-title">
                  caret down
                </title>
                <use xlinkHref="#anatomy-caret-down" />
              </svg>
            </button>
            <ul className="cms-sub-menu">
              <li className="cms-sub-menu__item">
                <div className="cms-sub-menu__link">
                  <a
                    id=""
                    title="Go to Health & Wellness"
                    data-test="go-to-health-wellness-nav-link"
                    className="cont_-IWPn0lJWClXD77WP3rXj link-content__link nav-link"
                    href="/healthprograms"
                  >
                    <span className="cms-nav-item__link-text">
                      Go to Health &amp; Wellness
                      <svg
                        className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-e6TXteWBj4Og8INecdNQ svg"
                        data-test="arrow-right-icon"
                        aria-label="arrow right"
                        role="img"
                        aria-hidden="true"
                      >
                        <title data-test="arrow-right-icon-title">
                          arrow right
                        </title>
                        <use xlinkHref="#arrow-right" />
                      </svg>
                    </span>
                  </a>
                </div>
                <div className="cms-sub-menu__divider" />
              </li>
              <li className="cms-sub-menu__item">
                <div className="cms-sub-menu__link">
                  <a
                    className="nav-link"
                    data-test="wellness-tools-nav-link-hash"
                    href="/healthprograms#wellness-tools"
                  >
                    <span className="cms-nav-item__link-text">
                      Wellness Tools{" "}
                    </span>
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </li>
        <li className="cms-nav-item">
          <div className="cms-nav-item__link cms-nav-item__link--parent">
            <button
              className="nav-link cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2 cont_-qica1OLHiA9mg6daoVDb"
              data-test="support-nav-link"
              type="button"
              aria-expanded="false"
            >
              <div className="cont_-xzf4zIOjrXt5rU5Pdx0v cms-nav-item__link-text">
                Support
              </div>
              <svg
                className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-WW6a0Ul_wZOcN9_J6EPn cont_-S6msaMk2pPmGHFiKKm7F"
                data-test="support-nav-link-svg"
                aria-label="caret down"
                role="img"
                aria-hidden="true"
              >
                <title data-test="support-nav-link-svg-title">caret down</title>
                <use xlinkHref="#anatomy-caret-down" />
              </svg>
            </button>
            <ul className="cms-sub-menu">
              <li className="cms-sub-menu__item">
                <div className="cms-sub-menu__link">
                  <a
                    id=""
                    title="Go to Support Center"
                    data-test="go-to-support-center-nav-link"
                    className="cont_-IWPn0lJWClXD77WP3rXj link-content__link nav-link"
                    href="/support"
                  >
                    <span className="cms-nav-item__link-text">
                      Go to Support Center
                      <svg
                        className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-e6TXteWBj4Og8INecdNQ svg"
                        data-test="arrow-right-icon"
                        aria-label="arrow right"
                        role="img"
                        aria-hidden="true"
                      >
                        <title data-test="arrow-right-icon-title">
                          arrow right
                        </title>
                        <use xlinkHref="#arrow-right" />
                      </svg>
                    </span>
                  </a>
                </div>
                <div className="cms-sub-menu__divider" />
              </li>
              <li className="cms-sub-menu__item">
                <div className="cms-sub-menu__link">
                  <a
                    aria-label="Contact Us (Opens in a new tab)"
                    className="cont_-IWPn0lJWClXD77WP3rXj link-content__link nav-link"
                    data-test="contact-us-nav-link"
                    href="https://member.aetna.com/secure/member/?v106#/openNavLite?deepLink=SSOPARTNERCONTACTUS"
                    target="_blank"
                  >
                    <span className="cms-nav-item__link-text">Contact Us</span>
                  </a>
                </div>
              </li>
              <li className="cms-sub-menu__item">
                <div className="cms-sub-menu__link">
                  <a
                    id=""
                    title="Documents"
                    data-test="documents-nav-link"
                    className="cont_-IWPn0lJWClXD77WP3rXj link-content__link nav-link"
                    href="/documents"
                  >
                    <span className="cms-nav-item__link-text">Documents</span>
                  </a>
                </div>
              </li>
              <li className="cms-sub-menu__item">
                <div className="cms-sub-menu__link">
                  <a
                    id=""
                    title="Forms"
                    data-test="forms-nav-link"
                    className="cont_-IWPn0lJWClXD77WP3rXj link-content__link nav-link"
                    href="/documents-and-forms"
                  >
                    <span className="cms-nav-item__link-text">Forms</span>
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </nav>
    <nav
      aria-label="secondary"
      data-test="cms-tertiary-nav"
      className="cms-tertiary-nav"
    >
      <ul className="cms-tertiary-nav__list">
        <li className="cms-nav-item">
          <div className="cms-nav-item__link cms-nav-item__link--parent">
            <button
              className="nav-link cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2 cont_-qica1OLHiA9mg6daoVDb"
              data-test="inbox-nav-link"
              type="button"
              aria-expanded="false"
            >
              <div className="cont_-xzf4zIOjrXt5rU5Pdx0v cms-nav-item__link-text">
                Inbox
              </div>
              <svg
                className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-WW6a0Ul_wZOcN9_J6EPn cont_-S6msaMk2pPmGHFiKKm7F"
                data-test="inbox-nav-link-svg"
                aria-label="caret down"
                role="img"
                aria-hidden="true"
              >
                <title data-test="inbox-nav-link-svg-title">caret down</title>
                <use xlinkHref="#anatomy-caret-down" />
              </svg>
            </button>
            <ul className="cms-sub-menu">
              <li className="cms-sub-menu__item">
                <div className="cms-sub-menu__link">
                  <a
                    id=""
                    title="Messages"
                    data-test="messages-nav-link"
                    className="cont_-IWPn0lJWClXD77WP3rXj link-content__link nav-link"
                    href="/messages"
                  >
                    <span className="cms-nav-item__link-text">Messages</span>
                  </a>
                </div>
              </li>
              <li className="cms-sub-menu__item">
                <div className="cms-sub-menu__link">
                  <a
                    id=""
                    title="Documents"
                    data-test="documents-nav-link"
                    className="cont_-IWPn0lJWClXD77WP3rXj link-content__link nav-link"
                    href="/documents"
                  >
                    <span className="cms-nav-item__link-text">Documents</span>
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </li>
        <li className="cms-nav-item">
          <div className="cms-nav-item__link cms-nav-item__link--parent">
            <button
              className="nav-link cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2 cont_-qica1OLHiA9mg6daoVDb"
              data-test="english-nav-link"
              type="button"
              aria-expanded="false"
            >
              <div className="cont_-xzf4zIOjrXt5rU5Pdx0v cms-nav-item__link-text">
                English
              </div>
              <svg
                className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-WW6a0Ul_wZOcN9_J6EPn cont_-S6msaMk2pPmGHFiKKm7F"
                data-test="english-nav-link-svg"
                aria-label="caret down"
                role="img"
                aria-hidden="true"
              >
                <title data-test="english-nav-link-svg-title">caret down</title>
                <use xlinkHref="#anatomy-caret-down" />
              </svg>
            </button>
            <ul className="cms-sub-menu">
              <li className="cms-sub-menu__item">
                <div className="cms-sub-menu__link cms-nav-item__link--active">
                  <button
                    className="nav-link cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2"
                    data-test="english-nav-link"
                    type="button"
                  >
                    <span className="cms-nav-item__link-text">English</span>
                  </button>
                </div>
              </li>
              <li className="cms-sub-menu__item">
                <div className="cms-sub-menu__link">
                  <button
                    className="nav-link cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2"
                    data-test="espanol-nav-link"
                    type="button"
                  >
                    <span className="cms-nav-item__link-text">Español</span>
                  </button>
                </div>
              </li>
            </ul>
          </div>
        </li>
        <li className="cms-nav-item">
          <div className="cms-nav-item__link cms-nav-item__link--parent">
            <button
              className="nav-link cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2 cont_-qica1OLHiA9mg6daoVDb"
              data-test="ziping-liu-nav-link"
              type="button"
              aria-expanded="false"
            >
              <div className="cont_-xzf4zIOjrXt5rU5Pdx0v cms-nav-item__link-text">
                Ziping Liu
              </div>
              <svg
                className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-WW6a0Ul_wZOcN9_J6EPn cont_-S6msaMk2pPmGHFiKKm7F"
                data-test="ziping-liu-nav-link-svg"
                aria-label="caret down"
                role="img"
                aria-hidden="true"
              >
                <title data-test="ziping-liu-nav-link-svg-title">
                  caret down
                </title>
                <use xlinkHref="#anatomy-caret-down" />
              </svg>
            </button>
            <ul className="cms-sub-menu">
              <li className="cms-sub-menu__item">
                <div className="cms-sub-menu__link">
                  <a
                    id=""
                    title="Profile & Preferences"
                    data-test="profile-preferences-nav-link"
                    className="cont_-IWPn0lJWClXD77WP3rXj link-content__link nav-link"
                    href="/preferences"
                  >
                    <span className="cms-nav-item__link-text">
                      Profile &amp; Preferences
                    </span>
                  </a>
                </div>
              </li>
              <li className="cms-sub-menu__item">
                <div className="cms-sub-menu__link">
                  <a
                    id=""
                    title="Forms"
                    data-test="forms-nav-link"
                    className="cont_-IWPn0lJWClXD77WP3rXj link-content__link nav-link"
                    href="/documents-and-forms"
                  >
                    <span className="cms-nav-item__link-text">Forms</span>
                  </a>
                </div>
              </li>
              <li className="cms-sub-menu__item">
                <div className="cms-sub-menu__link">
                  <button
                    className="nav-link cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2"
                    data-test="sign-out-nav-link"
                    type="button"
                  >
                    <span className="cms-nav-item__link-text">Sign Out</span>
                  </button>
                </div>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </nav>
  </div>
    )
}  